module.exports = __webpack_public_path__ + "img/全.png";